/**
 * Centralized API Configuration
 * Single source of truth for the backend API base URL.
 *
 * This value is loaded from the REACT_APP_API_URL environment variable.
 * - Local development: set in .env.local (http://localhost:5000/api)
 * - Production/server: set in .env.server (https://validaite.io/api)
 */
const API_BASE_URL = process.env.REACT_APP_API_URL || "https://dev.validaite.net/api";

export { API_BASE_URL };
